var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.493 5.807V8.6l-.822-.822-.822-.822-.338.355a6.497 6.497 0 0 0-.338.369c0 .007.636.649 1.414 1.427L8 10.52l1.413-1.413c.778-.778 1.414-1.42 1.414-1.427 0-.008-.152-.174-.338-.369l-.338-.355-.822.822-.822.822V3.013H7.493v2.794M3.019 11.06l.008 1.06.086.181c.114.242.344.472.586.586l.181.086h8.24l.181-.086c.242-.114.472-.344.586-.586l.086-.181.008-1.06.008-1.06H12V11.869l-.065.066-.066.065H4.131l-.066-.065L4 11.869V10h-.989l.008 1.06",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.9135ee339640689ff79078dda71ac7b6.svg";
export { ForwardRef as ReactComponent };